import { DataBean } from "../DataBean";

export class GuideDocType extends DataBean {




    public async getTransportGuideDocTypeConstants(args: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getTransportGuideDocTypeConstants_Number", [args]);
    }

}